import { getSize } from '../iterable/getSize';

export function isProductEdited(products) {
  function reduceProductsData(result, product) {
    return result || getSize(product.get('operations')) > 0;
  }

  return products.reduce(reduceProductsData, false);
}
